// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__pIuuW","addWidgetButton":"Header_addWidgetButton__hKJAR","dashboardTabs":"Header_dashboardTabs__7rHft","active":"Header_active__u91uu"};